module.exports = __webpack_public_path__ + "img/studentInvite.88033703.png";